<template>
  <div
      class="status-step"
      :class="{
        'is-done': step.isDone,
        'is-current': step.isCurrent,
        'is-available': step.isAvailable,
        'is-selected': step.isSelected,
        'is-revertable': step.isRevertable,
        'is-locked': step.isLocked,
        'is-terminal': step.isTerminal,
        'is-terminal-first': step.isTerminalFirst,
        'is-before-terminal': step.isBeforeTerminal,
        'is-readonly': readOnly,
      }"
      :title="step.title"
      @click="$emit('select', step)"
  >
    <span class="status-step-marker">
      <span v-if="step.isDone" class="status-step-check">&#10003;</span>
      <span v-else-if="step.isLocked" class="status-step-lock">&#128274;</span>
      <span v-else class="status-step-dot"></span>
    </span>

    <span class="status-step-body">
      <span class="status-step-label">{{ step.label }}</span>
      <span v-if="step.isCurrent" class="status-step-tag">Étape actuelle</span>
      <span v-else-if="step.isAvailable" class="status-step-tag status-step-tag-available">Étape suivante possible</span>
      <span v-if="step.isPending" class="status-step-tag">Sélectionné</span>
    </span>
  </div>
</template>

<script>

export default {
  name: 'StatusStep',
  props: {
    step: {type: Object, required: true},
    readOnly: {type: Boolean, default: false},
  },
  emits: ['select'],
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.status-step
  display flex
  align-items flex-start
  gap 10px
  padding 6px 4px
  border-radius 6px
  position relative

  &:not(:last-child):not(.is-before-terminal):not(.is-terminal)
    .status-step-marker
      &::after
        content ''
        position absolute
        top 22px
        left 50%
        transform translateX(-50%)
        width 2px
        height calc(100% - 3px)
        background-color #b8bec8

  &.is-done
    .status-step-marker
      background-color THEME_COLOR_PRIMARY
      border-color THEME_COLOR_PRIMARY

    .status-step-label
      color #3d4450

    .status-step-marker::after
      background-color THEME_COLOR_PRIMARY

  &.is-current
    .status-step-marker
      background-color THEME_COLOR_PRIMARY
      border-color THEME_COLOR_PRIMARY
      box-shadow 0 0 0 4px rgba(0, 0, 0, 0.04)

    .status-step-label
      color #14181f
      font-weight 700

  &.is-available
    cursor pointer

    .status-step-marker
      border-color THEME_COLOR_PRIMARY
      background-color #ffffff

    .status-step-label
      color #14181f
      font-weight 600

    &:hover
      background-color #f5f6f7

  // Workflow figé : les étapes disponibles ne sont pas cliquables.
  &.is-readonly.is-available
    cursor default
    opacity 0.75

  &.is-locked
    .status-step-marker
      border-color #aab1bc
      background-color #f5f6f7

    .status-step-label
      color #6a717d

  &.is-selected, &.is-selected:hover
    background-color #d8dfee

  &.is-revertable
    cursor pointer

  &.is-terminal-first
    margin-top 14px

  &.is-terminal
    .status-step-marker
      border-color #d68f8f

    .status-step-label
      color #8f2a2a

    &.is-selected, &.is-selected:hover
      background-color #fbeeee

    &.is-current, &.is-selected
      .status-step-marker
        background-color #c95050
        border-color #c95050

      .status-step-tag
        color #8f2a2a

    &.is-available:hover
      background-color #fbeeee

.status-step-marker
  flex 0 0 20px
  width 20px
  height 20px
  border-radius 50%
  border 2px solid #aab1bc
  background-color #ffffff
  display flex
  align-items center
  justify-content center
  position relative
  z-index 1

.status-step-check
  color #ffffff
  font-size 11px
  font-weight 700

.status-step-lock
  font-size 9px
  opacity 0.6

.status-step-dot
  width 6px
  height 6px
  border-radius 50%
  background-color #8a919d

.status-step-body
  display flex
  flex-direction column
  padding-top 1px

.status-step-label
  font-size 13px
  font-weight 600
  color #566070

.status-step-tag
  margin-top 2px
  font-size 10.5px
  font-weight 700
  text-transform uppercase
  letter-spacing 0.04em
  color THEME_COLOR_PRIMARY

.status-step-tag-available
  color #3d4450
</style>